import axios from "axios";
import { encryptRequest, decryptResponse } from "../utils/crypto";

const API_BASE_URL = process.env.REACT_APP_API_URL_NAME;
const RESPONSE_SECRET = process.env.REACT_APP_RESPONSE_SECRET;

export const isApiConfigured = Boolean(API_BASE_URL && RESPONSE_SECRET);

const CONFIG_ERROR_MESSAGE =
  "API configuration missing. Set REACT_APP_API_URL_NAME and REACT_APP_RESPONSE_SECRET in the environment file.";

const secureApi = axios.create({
  baseURL: `${API_BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
});
// REQUEST INTERCEPTOR
secureApi.interceptors.request.use(
  (config) => {
    if (!isApiConfigured) {
      const configError = new Error(CONFIG_ERROR_MESSAGE);
      configError.code = "ERR_CONFIG_MISSING";
      configError.response = {
        status: 0,
        data: { message: CONFIG_ERROR_MESSAGE },
      };
      return Promise.reject(configError);
    }

    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (typeof FormData !== "undefined" && config.data instanceof FormData) {
      if (config.headers) {
        delete config.headers["Content-Type"];
      }
      return config;
    }

    if (config.data) {
      config.data = encryptRequest(config.data);
    }
    return config;
  },
  (error) => Promise.reject(error)
);
// RESPONSE INTERCEPTOR
secureApi.interceptors.response.use(
  (response) => {
    response.data = decryptResponse(response.data);
    return response;
  },
  (error) => {
    if (error.response?.data) {
      error.response.data = decryptResponse(error.response.data);
    }

    if (error.response?.status === 401) {
      // Clear authentication data
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("role");
      localStorage.removeItem("permissions");

      // Clear session storage if used
      sessionStorage.clear();

      // Prevent redirect loop
      if (
        window.location.pathname !== "/login" &&
        window.location.pathname !== "/"
      ) {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);
export default secureApi;